import tibbit_05 from '@appblocks/codegeneration/tibbitDiagrams/tibbit_05.json';
import tibbit_10 from '@appblocks/codegeneration/tibbitDiagrams/tibbit_10.json';

export default {
    tibbit_05,
    tibbit_10,
};
